<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item prop="redeemNo" >
        <span slot="label" >
          <a-tooltip>
            {{$t('兑换单号(如: JF202502230001)')}}<template slot="title">{{$t('兑换单号(如: JF202502230001)')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.redeemNo" :maxLength="64" :placeholder="$t('请输入')+'兑换单号(如: JF202502230001)'" />
      </a-form-model-item>
      <a-form-model-item prop="userId" >
        <span slot="label" >
          <a-tooltip>
            {{$t('用户ID')}}<template slot="title">{{$t('用户ID')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.userId"  :placeholder="$t('请输入')+'用户ID'" />
      </a-form-model-item>
      <a-form-model-item prop="userName" >
        <span slot="label" >
          <a-tooltip>
            {{$t('用户昵称')}}<template slot="title">{{$t('用户昵称')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.userName" :maxLength="64" :placeholder="$t('请输入')+'用户昵称'" />
      </a-form-model-item>
      <a-form-model-item prop="userMobile" >
        <span slot="label" >
          <a-tooltip>
            {{$t('用户手机号')}}<template slot="title">{{$t('用户手机号')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.userMobile" :maxLength="32" :placeholder="$t('请输入')+'用户手机号'" />
      </a-form-model-item>
      <a-form-model-item prop="itemType" >
        <span slot="label" >
          <a-tooltip>
            {{$t('兑换类型 1=优惠券 2=实物礼品 3=虚拟权益')}}<template slot="title">{{$t('兑换类型 1=优惠券 2=实物礼品 3=虚拟权益')}}</template>
          </a-tooltip>
        </span>
      </a-form-model-item>
      <a-form-model-item prop="itemId" >
        <span slot="label" >
          <a-tooltip>
            {{$t('兑换对象ID')}}<template slot="title">{{$t('兑换对象ID')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.itemId"  :placeholder="$t('请输入')+'兑换对象ID'" />
      </a-form-model-item>
      <a-form-model-item prop="itemName" >
        <span slot="label" >
          <a-tooltip>
            {{$t('兑换对象名称')}}<template slot="title">{{$t('兑换对象名称')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.itemName" :maxLength="128" :placeholder="$t('请输入')+'兑换对象名称'" />
      </a-form-model-item>
      <a-form-model-item prop="consumePoints" >
        <span slot="label" >
          <a-tooltip>
            {{$t('消耗积分')}}<template slot="title">{{$t('消耗积分')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.consumePoints"  :placeholder="$t('请输入')+'消耗积分'" />
      </a-form-model-item>
      <a-form-model-item prop="status" >
        <span slot="label" >
          <a-tooltip>
            {{$t('状态 1=已完成 0=待处理 2=失败/作废')}}<template slot="title">{{$t('状态 1=已完成 0=待处理 2=失败/作废')}}</template>
          </a-tooltip>
        </span>
      </a-form-model-item>
      <a-form-model-item prop="redeemTime" >
        <span slot="label" >
          <a-tooltip>
            {{$t('兑换时间')}}<template slot="title">{{$t('兑换时间')}}</template>
          </a-tooltip>
        </span>
        <a-date-picker style="width: 100%" v-model="form.redeemTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <a-form-model-item prop="remark" >
        <span slot="label" >
          <a-tooltip>
            {{$t('备注')}}<template slot="title">{{$t('备注')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.remark" :placeholder="$t('请输入')" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getPointsRedeemRecord, addPointsRedeemRecord, updatePointsRedeemRecord } from '@/api/points/pointsRedeemRecord'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";


export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    CustomDictTag,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,

        redeemNo: null,

        userId: null,

        userName: null,

        userMobile: null,

        itemType: null,

        itemId: null,

        itemName: null,

        consumePoints: null,

        status: 0,

        redeemTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        redeemNo: [
          { required: true, message: '兑换单号(如: JF202502230001)'+this.$t('不能为空'), trigger: 'blur' }
        ],
        userId: [
          { required: true, message: '用户ID'+this.$t('不能为空'), trigger: 'blur' }
        ],
        userName: [
          { required: true, message: '用户昵称'+this.$t('不能为空'), trigger: 'blur' }
        ],
        userMobile: [
          { required: true, message: '用户手机号'+this.$t('不能为空'), trigger: 'blur' }
        ],
        itemType: [
          { required: true, message: '兑换类型 1=优惠券 2=实物礼品 3=虚拟权益'+this.$t('不能为空'), trigger: 'change' }
        ],
        itemName: [
          { required: true, message: '兑换对象名称'+this.$t('不能为空'), trigger: 'blur' }
        ],
        consumePoints: [
          { required: true, message: '消耗积分'+this.$t('不能为空'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: '状态 1=已完成 0=待处理 2=失败/作废'+this.$t('不能为空'), trigger: 'blur' }
        ],
        redeemTime: [
          { required: true, message: '兑换时间'+this.$t('不能为空'), trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        redeemNo: null,
        userId: null,
        userName: null,
        userMobile: null,
        itemType: null,
        itemId: null,
        itemName: null,
        consumePoints: null,
        status: 0,
        redeemTime: null,
        remark: null,
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getPointsRedeemRecord({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updatePointsRedeemRecord(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addPointsRedeemRecord(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
